/// <reference path="../../../tools/typings/tsd.d.ts"/>
/// <reference path="../services.ts"/>
/// <reference path="./contract_interfaces.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export class ContractInvoice implements IDealerwareContractInvoice {
        public static $inject: string[] = [
            '$q',
            '$timeout',
            'DealerwareContractModel'
        ];

        public locationId: number;
        public contractId : number;

        private _invoiceModel: any;
        private _data: any;
        private _validPricingSections: {}[];
        private _paymentSections: {}[];
        public pricingSectionDefinitions: {}[] = [{
            key: 'rental',
            title: 'Loan Charge'
        },{
            key: 'cleaning',
            title: 'Cleaning',
        },{
            key: 'damage',
            title: 'Damage'
        },{
            key: 'tickets_and_violations',
            title: 'Tickets & Violations'
        },{
            key: 'tolls',
            title: 'Tolls'
        },{
            key: 'fuel',
            title: 'Fuel'
        },{
            key: 'fuel_service_charge',
            title: 'Fuel Service Charge'
        },{
            key: 'odometer_charge',
            title: 'Excess Mileage'
        },{
            key: 'warranty',
            title: 'Warranty'
        },{
            key: 'adjustments',
            title: 'Other'
        },{
            key: 'taxes',
            title: 'Taxes'
        },{
            key: 'security_deposit',
            title: 'Security Deposit'
        }];
        public paymentSectionDefinitions: {}[] = [{
            key: 'payments',
            title: 'Payments'
        }];

        constructor(public $q: any,
                    public $timeout: any,
                    public DealerwareContractModel: any) {}

        get invoiceURL() : string {
            throw "invoiceURL() not implemented.";
        }

        get invoiceModel() : any {
            return this._invoiceModel;
        }

        set invoiceModel(m : any) {
            this._invoiceModel = m;
            this._data = undefined;
            this._validPricingSections = undefined;
        }

        get balance() : string {
            return (this.invoiceModel) ? this.invoiceModel.data.balance : 0;
        }

        get total() : string {
            return (this.invoiceModel) ? this.invoiceModel.data.total : 0;
        }

        get currencyCode() :   string {
            return (this.invoiceModel) ? this.invoiceModel.data.currency_code : null;
        }

        get currencySymbol() :   string {
            return (this.invoiceModel) ? this.invoiceModel.data.currency_symbol : null;
        }

        get id() :   number {
            return (this.invoiceModel) ? this.invoiceModel.data.id : null;
        }

        get data() : any {
            if (!this._data) {
                if (this._invoiceModel && this._invoiceModel.hasOwnProperty('data')) {
                    this._data = this._invoiceModel.data;
                }
                else {
                    this._data = {};
                }

            }
            return this._data;
        }

        set data(d : any) {
            if (this._invoiceModel && this._invoiceModel.hasOwnProperty('data') ){
                // todo: use setData on the model after checking it's a valid model
                this._invoiceModel.data = d;
            }
        }

        public get pricingSection() : {} {
            return (
                    this.data &&
                    angular.isObject(this.data) &&
                    this.data.hasOwnProperty('pricing') &&
                    this.data["pricing"] &&
                    angular.isObject(this.data["pricing"])
                ) ? this.data["pricing"] : undefined;
        }

        public get validPricingSections() :   {}[] {
            if (!this._validPricingSections) {
                var _self = this;

                if (this.pricingSection) {
                    this._validPricingSections = [];
                    this.pricingSectionDefinitions.forEach(function(val : any,idx : number) {
                        if (_self.hasPricingSectionItems(val.key)) {
                           _self._validPricingSections.push(
                               {
                                   key: val.key,
                                   title: val.title,
                                   total: _self.data["pricing"][val.key]["total"],
                                   items: _self.data["pricing"][val.key]["items"]
                                }
                            );
                        }
                    });
                }
            }
            return this._validPricingSections;
        }

        public get declinedPaymentSection() : any {
            return (
                    this.data &&
                    angular.isObject(this.data) &&
                    this.data.hasOwnProperty('last_declined_payment') &&
                    this.data['last_declined_payment'] &&
                    angular.isObject(this.data['last_declined_payment'])
                ) ? this.data['last_declined_payment'] : undefined;
        }

        public get paymentSection() : any {
            return (
                    this.data &&
                    angular.isObject(this.data) &&
                    this.data.hasOwnProperty('payments') &&
                    this.data["payments"] &&
                    angular.isObject(this.data["payments"])
                ) ? this.data["payments"] : undefined;
        }

        public get paymentSections() : {}[] {
            var paymentSections: {}[] = [];

            if (this.paymentSection || this.declinedPaymentSection) {
                if (this.declinedPaymentSection && this.declinedPaymentSection.hasOwnProperty('items')) {
                    paymentSections.push({
                        key: 'declined_payments',
                        title: this.declinedPaymentSection['label'],
                        total: this.declinedPaymentSection['total'],
                        items: this.declinedPaymentSection['items']
                    });
                }

                if (this.paymentSection && this.paymentSection.hasOwnProperty('items')) {
                    paymentSections.push({
                        key: 'payments',
                        title: this.paymentSection["label"],
                        total: this.paymentSection["total"],
                        items: this.paymentSection["items"]
                    });
                }
            }

            return paymentSections;
        }

        public clear() : void {
            this.data = undefined;
        }


        public load() : ng.IPromise<{}> {
            var _deferred = this.$q.defer();
            this.$timeout(function() {
                _deferred.reject({response: {data: {message: 'load() is not implemented'}}});
            },1);
            return _deferred.promise;
        }


        public hasPricingSectionItems(section : string) : boolean {
            var _h = false;
            if ( this.data && this.pricingSection
                && this.data["pricing"].hasOwnProperty(section)
                && this.data["pricing"][section]
                && this.data["pricing"][section].hasOwnProperty('items')
                && this.data["pricing"][section]["items"]
                && angular.isArray(this.data["pricing"][section]["items"])
                && this.data["pricing"][section]["items"].length > 0
                ) {
                    _h = true;
                }
            return _h;
        }

    }

    export class ContractInvoiceCurrent extends ContractInvoice implements IDealerwareContractInvoiceCurrent {
        get invoiceURL() : string {
            if (!this.locationId) { throw 'location id is undefined' }
            if (!this.contractId) { throw 'contract id is undefined'; }
            return '/location/' + this.locationId + '/reservations/' + this.contractId + '/receipt';
        }

        constructor(public $q: any,
                    public $timeout: any,
                    public DealerwareContractModel: any) {
            super($q,$timeout,DealerwareContractModel);
        }

        public load() : ng.IPromise<{}> {
            var _self       =   this;
            var _deferred   =   this.$q.defer();

            if (!this.locationId) {
                _deferred.reject({response:{data: {message: 'Location ID is undefined'}}});
            } else if (!this.contractId) {
                _deferred.reject({response:{data: {message: 'Contract ID is undefined'}}});
            } else {
                this.DealerwareContractModel.currentInvoice({
                    promise: true,
                    params: {
                        location_id: this.locationId,
                        id: this.contractId,
                        skinny: true
                    }
                }).then(
                    function(returnValue : any,response : any) {
                        _self.invoiceModel = returnValue;
                        _deferred.resolve({returnValue: returnValue,response: response});
                    },
                    function(response : any) {
                        _deferred.reject({response : response});
                    }
                );
            }

            return _deferred.promise;
        }
    }

    export class ContractInvoiceFactory implements IDealerwareContractInvoiceFactory {
        public static $inject: string[] = [
            '$q',
            '$timeout',
            'DealerwareContractModel'
        ];

        constructor(public $q: any,
                    public $timeout: any,
                    public DealerwareContractModel: any) {}

        getCurrentInvoiceInstance(locationId: number, contractId : number) : IDealerwareContractInvoiceCurrent {
            if (!contractId) {
                throw "contract id is not defined";
            }
            var _instance = new ContractInvoiceCurrent(this.$q,this.$timeout,this.DealerwareContractModel);
            _instance.locationId = locationId;
            _instance.contractId = contractId;
            return _instance;
        }

        getInvoiceInstance(contractId : number) : IDealerwareContractInvoice {
            if (!contractId) {
                throw "contract id is not defined";
            }
            var _instance = new ContractInvoice(this.$q,this.$timeout,this.DealerwareContractModel);
            _instance.contractId = contractId;
            return _instance;
        }
    }

    getDealerwareWebServicesModule().service("$DealerwareContractInvoiceFactory", ContractInvoiceFactory);
}
